var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-row',{staticStyle:{"padding":"0 10px"},attrs:{"type":"flex","align":"middle","gutter":10}},[_c('el-col',{staticStyle:{"padding":"0 10px"}},[_c('crnchy-price')],1),_c('el-col',{staticStyle:{"padding":"0 10px"}},[_c('usd-xtz-switch')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }